import Header from "../home/header"
import Ecommmercehero from "./ecommercehero"
import EcommerceDescription from "./ecommerceDescription"
import Technologies from "../home/technologies"
import HowwebuildProject from "../home/howwebuildProject"
import Contactnow from "../home/contactnow"
import Footer from "../home/footer" 
import Dreamcontact from "../home/dreamcontact"
const ecommercepage=()=>{
    return(
        <>
            <Header/>
            <Ecommmercehero/>
            <EcommerceDescription/>
            <Technologies/>
            <HowwebuildProject/>
            <Dreamcontact/>
            <Footer/>
        </>
    )
}
export default ecommercepage